module.exports = __webpack_public_path__ + "static/media/eh.4d3df256.svg";